<p-calendar [ngModel]="value"
            (ngModelChange)="valueChange.emit($event)"
            [dateFormat]="locale.dateFormat"
            [locale]="locale"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [appendTo]="appendTo"
            [disabled]="disabled"
></p-calendar>
